import { IHttpRequestConfig, get } from "@/browser";
import { applyHeaders, parseResponse } from "@/core/api";
import { compose } from "@/core/url";

import { CompanyDashboard, DashboardCountDto, PrivateDashboard } from "./types";

const API = {
  openApplications: "/api/dashboard/{consultantProfileId}/open-applications",
  ongoingAssignments: "/api/dashboard/{consultantProfileId}/ongoing-assignments",
  myTeam: "/api/dashboard/{consultantProfileId}/my-team",
  openJobs: "/api/dashboard/{consultantProfileId}/open-jobs",
  recommendedJobs: "/api/dashboard/{consultantProfileId}/recommended-jobs",
  savedJobs: "/api/dashboard/{consultantProfileId}/saved-jobs",
  admin: "/api/dashboard/admin/{consultantProfileId}",
  manager: "/api/dashboard/manager/{consultantProfileId}",
  private: "/api/dashboard/private/{consultantProfileId}",
};

export interface FetchDashboardProps {
  companyId?: number;
  consultantProfileId?: number;
}

export const fetchAdminDashboard = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.admin, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<CompanyDashboard>(CompanyDashboard));
};

export const fetchManagerDashboard = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.manager, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<CompanyDashboard>(CompanyDashboard));
};

export const fetchPrivateDashboard = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.private, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<PrivateDashboard>(PrivateDashboard));
};

export const fetchOpenApplications = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.openApplications, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};

export const fetchOngoingAssignments = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.ongoingAssignments, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};

export const fetchMyTeam = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.myTeam, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};

export const fetchOpenJobs = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.openJobs, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};

export const fetchRecommendedJobs = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.recommendedJobs, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};

export const fetchSavedJobs = (params: FetchDashboardProps, options?: IHttpRequestConfig) => {
  const { companyId, consultantProfileId, ...restParams } = params;

  const url = compose(API.savedJobs, { consultantProfileId }, restParams);

  return get(url, applyHeaders({ companyId }, options)).then(parseResponse<DashboardCountDto>(DashboardCountDto));
};
